<vbo-events
  [siteId]="widget.data.siteId || '1AC0E12D-B0DA-4047-8A09-EEC91977AC62'"
  [page]="widget.data.page || 'ListEvents'"
  [eid]="widget.data.eid || 0"
  [edid]="widget.data.edid || 0"
  [width]="widget.data.width || '100%'"
  [height]="widget.data.height || '400'"
  [bgColor]="widget.data.bgColor || 'transparent'">
</vbo-events>
